import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Locale } from 'libs.i18n-core';
import { DirContainer } from 'libs.localization.react';
import { DevicePreview } from 'libs.preview';
import { useDeviceScale } from '../../hooks/device_scale.hook';
const renderPreviewContent = (nodes, locale, showTopbar) => nodes?.map((child) => {
    const childKey = child.key ?? undefined;
    return (_jsx(DevicePreview, { showTopbar: showTopbar, children: _jsx(DirContainer, { locale: locale, children: child }) }, childKey));
}) || null;
export const AssetTranslationScreen = ({ PreviewComponent, basePreview, localePreview, baseProductMessages, localeProductMessages, sortIndex, screenIndex = 0, }) => {
    const baseLocale = Locale.en_US;
    const { locale = baseLocale } = useParams();
    const wrapperRef = useRef(null);
    const isComparisonMode = baseLocale !== locale;
    useDeviceScale(wrapperRef, isComparisonMode);
    const baseResult = PreviewComponent({
        productMessages: baseProductMessages,
        messages: basePreview,
        locale: baseLocale,
        sortIndex,
    });
    const localeResult = PreviewComponent({
        productMessages: localeProductMessages,
        messages: localePreview,
        locale: locale,
        sortIndex,
    });
    const baseScreens = baseResult || [];
    const localeScreens = localeResult || [];
    const baseNode = baseScreens[screenIndex] || null;
    const localeNode = localeScreens[screenIndex] || null;
    return (_jsx("div", { ref: wrapperRef, children: _jsxs("div", { className: 'mb-8 flex gap-4 justify-center w-fit', children: [renderPreviewContent(baseNode ? [baseNode] : null, baseLocale, false), isComparisonMode && renderPreviewContent(localeNode ? [localeNode] : null, locale, false)] }) }));
};
